// extracted by mini-css-extract-plugin
export default {"layout-root":"VRbMgurSFiEfX5wPChR4"};